import { createReducer, on } from '@ngrx/store';
import { AttrezzatureActions } from './attrezzature.actions';
import { Attrezzatura, AttrezzatureQueryParams, AttrezzaturaAssociazione } from '../../core/models/attrezzature.model';

export interface AttrezzatureState {
  items: Attrezzatura[];
  loading: boolean;
  error: string | null;

  totalElements: number;
  totalPages: number;
  pageIndex: number;
  pageSize: number;
  lastQuery: AttrezzatureQueryParams | undefined;

  selected: Attrezzatura | null;
  createSuccessCount: number;
  updateSuccessCount: number;

  storicoAssociazioni: AttrezzaturaAssociazione[];
  storicoLoading: boolean;
  storicoError: string | null;

  opLoading: boolean;
  opError: string | null;
}

export const initialState: AttrezzatureState = {
  items: [],
  loading: false,
  error: null,

  totalElements: 0,
  totalPages: 0,
  pageIndex: 0,
  pageSize: 20,
  lastQuery: undefined,

  selected: null,
  createSuccessCount: 0,
  updateSuccessCount: 0,

  storicoAssociazioni: [],
  storicoLoading: false,
  storicoError: null,

  opLoading: false,
  opError: null,
};

export const AttrezzatureReducer = createReducer(
  initialState,

  // LISTA
  on(AttrezzatureActions.loadList, (s, { params }) => ({ ...s, loading: true, error: null, lastQuery: params })),
  on(AttrezzatureActions.loadListSuccess, (s, { items, totalElements, totalPages, pageIndex }) => ({
    ...s,
    loading: false,
    items,
    totalElements,
    totalPages,
    pageIndex,
  })),
  on(AttrezzatureActions.loadListFailure, (s, { error }) => ({ ...s, loading: false, error })),

  // DETTAGLI
  on(AttrezzatureActions.loadDetails, (s) => ({ ...s, opLoading: true, opError: null })),
  on(AttrezzatureActions.loadDetailsSuccess, (s, { item }) => ({ ...s, opLoading: false, selected: item })),
  on(AttrezzatureActions.loadDetailsFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),

  // CREATE
  on(AttrezzatureActions.create, (s) => ({ ...s, opLoading: true, opError: null })),
  on(AttrezzatureActions.createSuccess, (s) => ({ ...s, opLoading: false, createSuccessCount: s.createSuccessCount + 1 })),
  on(AttrezzatureActions.createFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),

  // UPDATE
  on(AttrezzatureActions.update, (s) => ({ ...s, opLoading: true, opError: null })),
  on(AttrezzatureActions.updateSuccess, (s) => ({ ...s, opLoading: false, updateSuccessCount: s.updateSuccessCount + 1 })),
  on(AttrezzatureActions.updateFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),

  // SET AVAILABLE
  on(AttrezzatureActions.setAvailable, (s) => ({ ...s, opLoading: true, opError: null })),
  on(AttrezzatureActions.setAvailableSuccess, (s) => ({ ...s, opLoading: false })),
  on(AttrezzatureActions.setAvailableFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),

  // ASSOCIATE TO CANTIERE
  on(AttrezzatureActions.associateToCantiere, (s) => ({ ...s, opLoading: true, opError: null })),
  on(AttrezzatureActions.associateToCantiereSuccess, (s) => ({ ...s, opLoading: false })),
  on(AttrezzatureActions.associateToCantiereFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),

  // END CANTIERE ASSOCIATION
  on(AttrezzatureActions.endCantiereAssociation, (s) => ({ ...s, opLoading: true, opError: null })),
  on(AttrezzatureActions.endCantiereAssociationSuccess, (s) => ({ ...s, opLoading: false })),
  on(AttrezzatureActions.endCantiereAssociationFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),

  // ASSOCIATE TO FORNITORE
  on(AttrezzatureActions.associateToFornitore, (s) => ({ ...s, opLoading: true, opError: null })),
  on(AttrezzatureActions.associateToFornitoreSuccess, (s) => ({ ...s, opLoading: false })),
  on(AttrezzatureActions.associateToFornitoreFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),

  // END FORNITORE ASSOCIATION
  on(AttrezzatureActions.endFornitoreAssociation, (s) => ({ ...s, opLoading: true, opError: null })),
  on(AttrezzatureActions.endFornitoreAssociationSuccess, (s) => ({ ...s, opLoading: false })),
  on(AttrezzatureActions.endFornitoreAssociationFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),

  // ARCHIVE
  on(AttrezzatureActions.archive, (s) => ({ ...s, opLoading: true, opError: null })),
  on(AttrezzatureActions.archiveSuccess, (s) => ({ ...s, opLoading: false })),
  on(AttrezzatureActions.archiveFailure, (s, { error }) => ({ ...s, opLoading: false, opError: error })),

  // STORICO ASSOCIAZIONI
  on(AttrezzatureActions.loadStoricoAssociazioni, (s) => ({ ...s, storicoLoading: true, storicoError: null })),
  on(AttrezzatureActions.loadStoricoAssociazioniSuccess, (s, { items }) => ({
    ...s,
    storicoLoading: false,
    storicoAssociazioni: items,
  })),
  on(AttrezzatureActions.loadStoricoAssociazioniFailure, (s, { error }) => ({ ...s, storicoLoading: false, storicoError: error })),
);
